import { render, staticRenderFns } from "./ComplaintsTable.vue?vue&type=template&id=2801fb5a"
import script from "./ComplaintsTable.vue?vue&type=script&lang=js"
export * from "./ComplaintsTable.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsTable.vue?vue&type=style&index=0&id=2801fb5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports